import React, { useState, useEffect } from "react";
import styled from "styled-components";
import CarouselBanner from "./carouselDesktop";
import CarouselBannerMobile from "./carouselMobile";
import ReferidosSwitch from "./referidos/switch";

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  flex-direction: row;
  background-color: var(--white);
`;

export default function Carousel() {
  // Popup referidos open close
  const [isOpen, setIsOpen] = useState(false);
  const togglePopup = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    setTimeout(() => {
      togglePopup();
    }, 3000);
  }, []);

  return (
    <Container>
      {/* Carousel con banner */}
      {/* Para que se no se vea hidden="active" */}
      <CarouselBanner
        hidden=""
        togglePopup={isOpen == false && togglePopup}
      ></CarouselBanner>
      {/* Carousel con banner mobile*/}
      {/* Para que se no se vea hidden="active" */}
      <CarouselBannerMobile
        hidden=""
        togglePopup={isOpen == false && togglePopup}
      ></CarouselBannerMobile>
      {isOpen && <ReferidosSwitch handleClose={togglePopup} />}
    </Container>
  );
}
